import { render, staticRenderFns } from "./IconCompetencyGap.vue?vue&type=template&id=709a91f8"
import script from "./IconCompetencyGap.vue?vue&type=script&lang=js"
export * from "./IconCompetencyGap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports